export const styles = {
  widgetLink: {
    color: 'inherit',
    textDecoration: 'none',
    height: '100%',
    width: '100%',
  },
};
